import React from "react";
import { FunctionGetPathUrl } from "../../utils/useFunction";
import { ICON_INFO } from "../../utils/useIcons";
import { STYLE_ICON_INFO_INPROGRAM } from "../../utils/useStyle";
import { DrawerInfo } from "../drawerInfo/DrawerInfo.Main";

const IconInfoWithModalMain = ({
  icon,
  title,
  image,
  imageMobile,
  description,
  classNameWrapper,
  classNameSubTitle,
  renderBody,
  modalItitle,
  classNameIcon = STYLE_ICON_INFO_INPROGRAM,
  classNameDrawer,
  parentDrawerInfo,
  onClickInfo,
  description2,
  showIconInfo = true,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <div className={classNameWrapper}>
        {icon ? icon : <React.Fragment />}
        {classNameSubTitle ? (
          <div className={classNameSubTitle}>
            {title ? title : <React.Fragment />}
            {renderBody ? renderBody : <React.Fragment />}
          </div>
        ) : (
          [title ? title : <React.Fragment />]
        )}
        {showIconInfo && (
          <ICON_INFO
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
            className={classNameIcon}
          />
        )}
      </div>
      <div className={classNameDrawer}>
        <DrawerInfo
          open={open}
          setOpen={setOpen}
          image={image ? FunctionGetPathUrl(image) : ""}
          title={modalItitle}
          description={description}
          parentDrawerInfo={parentDrawerInfo}
          description2={description2}
          imageMobile={imageMobile ? FunctionGetPathUrl(imageMobile) : ""}
        />
      </div>
    </React.Fragment>
  );
};

export default IconInfoWithModalMain;
